var collapsible_list_component_rtlignore_default = {
  "ltr": "CSK52",
  "rtl": "nI6IK",
  "iconContainer": "oUnuH",
  "icon": "RlhBe",
  "isExpanded": "fW-Eg",
  "listDimensions": "ldrAX"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
